import ServiceBase from "base/baseService"

export default class TipoProdutoService extends ServiceBase {

    title = "Tipo de produto"
    pluralTitle = "Tipo de produtos"
    url = '/cadastro/produto/tipoproduto'
    frontUrl = '/cadastro/produto/tipoproduto'
    frontUrlList = '/cadastro/produto/tipoprodutolist'
    primaryKey = 'codigo_tipp'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        return data
    }

    prepareToSave({ data }) {

        delete data.meta

        return data

    }

}
